import { subscribe, getState } from "../state/store";
import { qs } from "../utils/dom";
import { mountClassSwitcher } from "./components/ClassSwitcher";
import { mountConstraints } from "./components/ConstraintsEditor";
import { mountGroupsBoard } from "./components/GroupsBoard";
import { mountProgress } from "./progress";
import { createModeToggle } from "./components/ModeToggle";
import { createSeatingChartView } from "./components/SeatingChartView";
import { createProximityEditor } from "./components/ProximityEditor";

export function mountAll() {
    mountClassSwitcher();
    mountConstraints();
    mountProgress();
    mountGroupsBoard();

    // Mount mode toggle
    const modeToggleSection = qs<HTMLElement>("#mode-toggle");
    modeToggleSection.appendChild(createModeToggle());

    // Mount seating chart view
    const seatingViewSection = qs<HTMLElement>("#seating-view");
    seatingViewSection.appendChild(createSeatingChartView());

    // Mount proximity editor in sidebar
    const proximitySection = qs<HTMLElement>("#proximity-editor");
    proximitySection.appendChild(createProximityEditor());

    // Update visibility based on mode
    function updateModeVisibility() {
        const s = getState();
        const cls = s.classes.find(c => c.id === s.activeClassId);
        const mode = cls?.settings.mode ?? 'groups';

        // Toggle visibility of mode-specific sections
        document.querySelectorAll('.mode-groups').forEach(el => {
            el.classList.toggle('hidden', mode !== 'groups');
        });
        document.querySelectorAll('.mode-seating').forEach(el => {
            el.classList.toggle('hidden', mode !== 'seating');
        });
    }

    // Initial visibility
    updateModeVisibility();

    // Listen for mode changes
    document.addEventListener("mode:change", updateModeVisibility);

    subscribe(() => {
        document.dispatchEvent(new CustomEvent("state:update"));
        updateModeVisibility();
    });
}
